/**
 * BCR button component for package list — color-coded by BCR status.
 */

import { Button, Tooltip } from 'antd';
import {
  ExperimentOutlined,
  CheckCircleFilled,
  SyncOutlined,
  CloseCircleFilled,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { BcrTaskStatus } from '@/types';
import { useT } from '@/i18n';

interface BcrButtonProps {
  projectId: number;
  packageId: number;
  status: BcrTaskStatus | null;
}

const statusConfig: Record<string, { color: string; icon: React.ReactNode; tip: string }> = {
  finished: {
    color: '#52c41a',
    icon: <CheckCircleFilled style={{ color: '#52c41a' }} />,
    tip: 'BCR测试完成',
  },
  running: {
    color: '#faad14',
    icon: <SyncOutlined spin style={{ color: '#faad14' }} />,
    tip: 'BCR测试运行中',
  },
  stop: {
    color: '#ff4d4f',
    icon: <CloseCircleFilled style={{ color: '#ff4d4f' }} />,
    tip: 'BCR测试已终止',
  },
  pending: {
    color: '#d9d9d9',
    icon: <ExperimentOutlined style={{ color: '#8c8c8c' }} />,
    tip: 'BCR测试排队中',
  },
};

const defaultConfig = {
  color: undefined,
  icon: <ExperimentOutlined />,
  tip: 'BCR测试',
};

const BcrButton: React.FC<BcrButtonProps> = ({ projectId, packageId, status }) => {
  const navigate = useNavigate();
  const { t } = useT();
  const cfg = status ? statusConfig[status] || defaultConfig : defaultConfig;

  return (
    <Tooltip title={t(cfg.tip)}>
      <Button
        type="text"
        size="small"
        icon={cfg.icon}
        onClick={() => navigate(`/packages/${projectId}/bcr/${packageId}`)}
      />
    </Tooltip>
  );
};

export default BcrButton;
